import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import Icon from '../../../components/Icon';
import Tabs from '../../../components/Tabs';
import Title from '../../../components/Title';
import { useGetDeviceQuery } from '../../../api/deviceApiSlice';
import { Loader } from '../../../components/components';
import RequestList from '../../../components/devices/RequestList';
import DeviceMap from '../../../components/devices/DeviceMap';
import MonitoredDeviceFormModal from '../../../components/devices/MonitoredDeviceFormModal';
import AdminGeneralDevice from '../../../components/devices/AdminGeneralDevice';

const Device = () => {
  const {sptId} = useParams();
  const { t } = useTranslation();
  const history = useHistory();
  const {data: device={}, isLoading, isSuccess} = useGetDeviceQuery(sptId)
  const [showMonitorModal, setShowMonitorModal] = useState(false)
  const addToMonitored = () => setShowMonitorModal(true)
  const monitorLabel = device.monitored ? t("devices.editToMonitored") : t("devices.addToMonitored")

  return ( <>
    <Title main="device" sub={sptId + " - " + device.os} onBack={() => history.push(`/devices`)}>
      <Button onClick={addToMonitored}>
        <Icon icon='plus' text={monitorLabel} />
      </Button>
      <Button onClick={()=> history.push(`/devices/${device.id}/sdk/remote_configuration`)}>
        <Icon icon='branch' text={t("devices.remoteParams")} />
      </Button>
    </Title>
    <MonitoredDeviceFormModal show={showMonitorModal} sptId={sptId} setShow={setShowMonitorModal}/>
    <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
      <Tabs active={"general"}>
        <AdminGeneralDevice as={"general"} icon={"home"} device={device}/>
        <RequestList as={"requests"} icon={"info"} sptId={sptId}/>
        <DeviceMap as={"map"} icon={"map-location"} sptId={sptId}/>
      </Tabs>
    </Loader>
  </> );
}

export default Device;
